
export default {
  methods: {
    enableScroll(element) {
      const stopPropagation = (e) => e.stopPropagation();

      if (element.addEventListener)
        element.addEventListener('DOMMouseScroll', stopPropagation, false);
      element.addEventListener('wheel', stopPropagation, false);
      element.addEventListener('mousewheel', stopPropagation, false);
      element.addEventListener('mousewheel', stopPropagation, false);
      element.addEventListener('touchmove', stopPropagation, false);
    }
  }
}



// WEBPACK FOOTER //
// ./components/mixins/EnableScroll.vue